<template>
  <modal :is-open="itemModalOpen"
         :closeable="false">

    <div>
      {{ selectedItem.name }}: {{ selectedItem.description }}
    </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="itemModalOpen=false;">
        {{ translation.general.cancel }}
      </button>
    </template>
  </modal>

  <br>

  <div class="container">
    <h5 class="pokemon-list__title">
      New missions in: <br>{{ endDate }}
    </h5>
  </div>

  <div v-for="mission in missions" :key="mission">
    <div class="missions" style="display: flex;" :class="{ 'missions-done' : mission.progress >= mission.goal}">
      <div style="width: 75%;">
        {{ mission.name }} <br>
        {{ mission.progress }} / {{ mission.goal }}
      </div>

      <div style="width: 25%;top:2vh;" class="col-3 itemn-list__entry">
        <div style="position: relative;">
          <ItemEntryButton v-if="mission.rewardItem" :id="mission.rewardItem.id"
                           :sprite_name="mission.rewardItem.sprite_name" :amount="mission.rewardItem.amount"
                           @click="selectedItem = mission.rewardItem;itemModalOpen=true;"/>

          <PokemonEntryButton
              v-else-if="mission.rewardPokemon"
              :pokedex-id="mission.rewardPokemon.id"
              :id="mission.rewardPokemon.id" :name="mission.rewardPokemon.name"
              :is-shiny="false" :sell-price="0"
              :lvl="'?'" :hpPercent="100" :is-buddy="false"
              @click="selectedItem = mission.rewardPokemon;itemModalOpen=true;"/>
        </div>

      </div>
    </div>
    <br>
  </div>


</template>

<script>
import {startLoadingProcess, stopLoadingProcess} from "@/components/LoadingOverlay/loadingOverlayControl";
import axios from "axios";
import {backendUri} from "@/utils/settings";
import {translation} from "@/utils/translations";
import {onMounted} from "@vue/runtime-core";
import {ref} from "@vue/reactivity";
import ItemEntryButton from "@/components/ItemEntryButton/ItemEntryButton";
import Modal from "@/components/Modal/Modal";
import PokemonEntryButton from "@/components/PokemonEntryButton/PokemonEntryButton";
import {handleUnknownError} from "@/utils/utilities";

export default {
  name: "Mission",
  components: {
    ItemEntryButton,
    Modal,
    PokemonEntryButton
  },
  setup() {
    const endDate = ref("");
    const missions = ref([]);
    const itemModalOpen = ref(false);
    const selectedItem = ref();
    const refreshView = async () => {
      startLoadingProcess();
      await axios.get(backendUri + "api/game/ext/trainer/mission/",)
          .then(resp => {
            missions.value = resp.data.missions
            endDate.value = resp.data.endDate
          })
          .catch(error => {
            handleUnknownError(error);
          })
      stopLoadingProcess();
    };

    onMounted(() => {
      refreshView();

    });

    return {
      translation,
      missions,
      refreshView,
      selectedItem,
      itemModalOpen,
      endDate
    }
  }
}
</script>

<style lang="scss">
.missions {
  color: white;
  width: 80%;
  background-color: #3c3f41;
  margin: auto;
  border-radius: 10px;
  padding: 12px;


  &-done {
    background-color: #1c7e1e;
  }
}
</style>